<template>
  <div class="h-100">
    <section class="d-flex p-3 h-100 w-100">
      <section class="w-40 h-100">
        <!-- Hiring Process Section -->
        <template v-if="!isIpSelected && !isFeedbackFormSelected">
          <div class="select-int-font pl-1 pb-1">
            Select Hiring Process<span class="asterik">*</span>
          </div>
          <div class="relativeclass">
            <div
              @click="goToHiringModal('interviewProcess')"
              class="new-div pointer d-flex align-items-center"
              :class="{
                error:
                  validateObj.interviewProcess.$error ||
                  validateObj.interviewProcess.feedbackFormID.$error,
              }"
            >
              <div class="mr-2">
                <img
                  src="../../../assets/new-createjobs/hiringProcess-icon.svg"
                  alt="Hiring Process Icon"
                />
              </div>
              <div class="new-div-head mr-2">Select from existing</div>
              <div class="new-div-sub mr-2 mt-1">OR</div>
              <div class="new-div-head">Create new</div>
            </div>
            <div
              class="newInt-required-validation-font mt-1"
              v-if="
                validateObj.interviewProcess.$error ||
                validateObj.interviewProcess.feedbackFormID.$error
              "
            >
              Required
            </div>
          </div>
        </template>

        <template v-else>
          <template
            v-if="
              (!isJdApproved &&
                isFeedbackFormPresent &&
                !isFeedbackFormSelected) ||
              (!isJdApproved && !isFeedbackFormSelected)
            "
          >
            <div class="select-int-font pl-1 pb-1">
              Select Feedback Form<span class="asterik">*</span>
            </div>
            <div class="relativeclass">
              <div
                @click="goToHiringModal('feedbackForm')"
                class="new-div pointer d-flex align-items-center"
                :class="{
                  error: validateObj.interviewProcess.feedbackFormID.$error,
                }"
              >
                <div class="mr-2">
                  <img
                    src="../../../assets/new-createjobs/hiringProcess-icon.svg"
                    alt="Feedback Form Icon"
                  />
                </div>
                <div class="new-div-head mr-2">Select from existing</div>
                <div class="new-div-sub mr-2 mt-1">OR</div>
                <div class="new-div-head">Create new</div>
              </div>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="validateObj.interviewProcess.feedbackFormID.$error"
              >
                Required
              </div>
            </div>
            <hr class="mt-4" />
          </template>
          <template v-else-if="isFeedbackFormSelected">
            <div class="select-int-font pl-1 pb-1">
              Select Feedback Form<span class="asterik">*</span>
            </div>
            <div class="new-div d-flex align-items-center mb-3">
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="w-80 text-truncate">
                  <img
                    class="mr-2"
                    src="../../../assets/new-createjobs/hiringProcess-icon.svg"
                    alt="Feedback Form Icon"
                  />
                  <span class="new-div-head mr-2">{{
                    savedFeedback.name
                  }}</span>
                </div>
                <div v-if="!isJdApproved">
                  <img
                    @click="goToHiringModal('feedbackForm')"
                    class="mr-2 pointer"
                    src="../../../assets/new-createjobs/jobs-reselect.svg"
                    alt="Feedback Form Icon"
                  />
                  <img
                    @click="$emit('delete-feedback')"
                    class="pointer"
                    src="../../../assets/new-createjobs/jobs-delete.svg"
                    alt="Feedback Form Icon"
                  />
                </div>
              </div>
            </div>
            <hr />
          </template>
          <!-- Interview Process Section -->
          <template v-if="!isIpSelected">
            <div class="select-int-font pl-1 pb-1">
              Select Interview Process<span class="asterik">*</span>
            </div>
            <div class="relativeclass">
              <div
                @click="goToHiringModal('interviewProcess')"
                class="new-div d-flex align-items-center pointer"
                :class="{
                  error: validateObj.interviewProcess.$error,
                }"
              >
                <div class="mr-2">
                  <img
                    src="../../../assets/new-createjobs/interviewProcess-icon.svg"
                    alt="Interview Process Icon"
                  />
                </div>
                <div class="new-div-head mr-2">Select from existing</div>
                <div class="new-div-sub mr-2 mt-1">OR</div>
                <div class="new-div-head">Create new</div>
              </div>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="validateObj.interviewProcess.$error"
              >
                Required
              </div>
            </div>
          </template>
          <template v-else-if="isIpSelected">
            <div class="select-int-font pl-1 pb-1">
              Select Interview Process<span class="asterik">*</span>
            </div>
            <div class="new-div d-flex align-items-center">
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="w-80 text-truncate">
                  <img
                    class="mr-2"
                    src="../../../assets/new-createjobs/interviewProcess-icon.svg"
                    alt="Feedback Form Icon"
                  />
                  <span class="new-div-head mr-2">{{ savedIP.name }}</span>
                </div>
                <div v-if="!isJdApproved">
                  <img
                    @click="goToHiringModal('interviewProcess')"
                    class="mr-2 pointer"
                    src="../../../assets/new-createjobs/jobs-reselect.svg"
                    alt="Feedback Form Icon"
                  />
                  <img
                    @click="$emit('delete-interview')"
                    class="pointer"
                    src="../../../assets/new-createjobs/jobs-delete.svg"
                    alt="Feedback Form Icon"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>

        <!-- Process Rounds Display -->
        <div v-if="isIpSelected" class="ip-selected-height pr-1 mt-3">
          <div
            v-for="(round, index) in savedIP.process"
            :key="index + 'process'"
            class="mb-2"
          >
            <template v-if="checkValidRound(round.id)">
              <div
                class="
                  createjob-ip-roundcards
                  d-flex
                  align-items-center
                  pointer
                "
                @click="switchRounds(round.id)"
                :class="{
                  error:
                    (round.type === 'f2f' &&
                      (!validateObj.faceToFaceRounds.$each[
                        processMap[round.id].index
                      ].endDate.isDateValid ||
                        !validateObj.faceToFaceRounds.$each[
                          processMap[round.id].index
                        ].startDate.isStartDateBeforeEndDatef2f ||
                        !validateObj.faceToFaceRounds.$each[
                          processMap[round.id].index
                        ].endDate.isEndDateAfterStartDatef2f ||
                        validateObj.faceToFaceRounds.$each[
                          processMap[round.id].index
                        ].$error)) ||
                    (round.type === 'assesment' &&
                      (!validateObj.assessmentRounds.$each[
                        processMap[round.id].index
                      ].closeTestdt.isDateValid ||
                        !validateObj.assessmentRounds.$each[
                          processMap[round.id].index
                        ].openTestdt.isStartDateBeforeEndDate ||
                        !validateObj.assessmentRounds.$each[
                          processMap[round.id].index
                        ].closeTestdt.isEndDateAfterStartDate ||
                        validateObj.assessmentRounds.$each[
                          processMap[round.id].index
                        ].duration.$error ||
                        validateObj.assessmentRounds.$each[
                          processMap[round.id].index
                        ].$error)),
                  'createjob-ip-roundselectedcards':
                    currentRoundID === round.id,
                  'mt-2': index > 1,
                }"
              >
                <div class="createjob-ip-roundcardsline"></div>
                <div
                  class="
                    w-100
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <div class="createjob-round-text pl-1 w-80 text-truncate">
                    {{ round.name }}
                  </div>
                  <div class="createjob-round-type-txt">
                    ({{ round.type === "f2f" ? "Face to face" : "Assessment" }})
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </section>
      <section class="w-60 pff-add-right-container ml-3 h-100">
        <template v-if="!isIpSelected">
          <div
            class="
              h-100
              w-100
              d-flex
              align-items-center
              justify-content-center
              flex-column
            "
          >
            <div class="d-flex align-items-center">
              <img
                src="../../../assets/img/newcreatejob/interviewprocess/empty.svg"
                alt=""
              />
            </div>
            <div class="createjob-empty-txt">
              Please select the “Interview Process” from the left side panel
            </div>
          </div>
        </template>
        <template v-else>
          <div class="createjob-ip-header">
            Round {{ currentRoundID }}
            <span class="createjob-ip-header-type"
              >({{
                processMap[currentRoundID].type === "assessment"
                  ? "Assessment"
                  : "Face to face"
              }})</span
            >
          </div>
          <template v-if="processMap[currentRoundID].type === 'assessment'">
            <div class="p-3">
              <b-row>
                <b-col>
                  <div class="newmodal-input-label">
                    Start Date & Time<span class="asterik">*</span>
                  </div>
                  <div class="position-relative newmodalinputbox mt-1">
                    <DatePicker
                      ref="start-asmnt"
                      class="w-100 startdateconfig-tc global-disabledField"
                      :class="{
                        'error-dp-tc':
                          validateObj.assessmentRounds.$each[currentRoundIndex]
                            .openTestdt.$error,
                      }"
                      placeholder="Select start date & time"
                      :format="dateDisplayFormat"
                      :value-type="dateValueFormat"
                      type="datetime"
                      :editable="false"
                      v-model="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .openTestdt.$model
                      "
                      :disabled-date="disableStartDate"
                      :disabled-time="disableStartTime"
                    />
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .openTestdt.$dirty &&
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .openTestdt.required
                      "
                    >
                      Required
                    </div>
                    <div
                      class="createjob-ip-calemndar pointer"
                      @click="openDate('start-asmnt')"
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/calendar.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="newmodal-input-label">
                    End Date & Time<span class="asterik">*</span>
                  </div>
                  <div class="position-relative newmodalinputbox mt-1">
                    <DatePicker
                      ref="end-asmnt"
                      class="w-100 startdateconfig-tc global-disabledField"
                      :class="{
                        'error-dp-tc':
                          validateObj.assessmentRounds.$each[currentRoundIndex]
                            .closeTestdt.$error ||
                          !validateObj.assessmentRounds.$each[currentRoundIndex]
                            .closeTestdt.isDateValid,
                      }"
                      placeholder="Select end date & time"
                      :format="dateDisplayFormat"
                      :value-type="dateValueFormat"
                      type="datetime"
                      v-model="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.$model
                      "
                      :editable="false"
                      :disabled-date="disableEndDate"
                      :disabled-time="disableStartTime"
                    />
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.$dirty &&
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.required
                      "
                    >
                      Required
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.$dirty &&
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.isDateValid
                      "
                    >
                      End date & time cannot be less than current
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.$dirty &&
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.isDateValid &&
                        (!validateObj.assessmentRounds.$each[currentRoundIndex]
                          .closeTestdt.isEndDateAfterStartDate ||
                          !validateObj.assessmentRounds.$each[currentRoundIndex]
                            .openTestdt.isStartDateBeforeEndDate)
                      "
                    >
                      End date & time must be after the start
                    </div>
                    <div
                      class="createjob-ip-calemndar pointer"
                      @click="openDate('end-asmnt')"
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/calendar.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="newmodal-input-label">
                    Duration<span class="asterik">*</span>
                  </div>
                  <div class="position-relative newmodalinputbox mt-1">
                    <b-form-input
                      @keypress="NumbersOnly"
                      :class="{
                        error:
                          validateObj.assessmentRounds.$each[currentRoundIndex]
                            .duration.$error,
                      }"
                      placeholder="Enter duration in minutes"
                      v-model="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.$model
                      "
                    >
                    </b-form-input>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.$dirty &&
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.required
                      "
                    >
                      Required
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.integer ||
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.minValue
                      "
                    >
                      Should be greater than 5 minutes
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.$dirty &&
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.required &&
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .duration.durationError
                      "
                    >
                      The difference between end time and start time cannot be
                      less than the test duration
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <div
                    class="
                      mt-3
                      sendautomatically
                      common-single-checkbox
                      d-flex
                      align-items-center
                    "
                  >
                    <b-form-checkbox
                      :disabled="
                        automatedJob ||
                        processMap[currentRoundID].actualIndex === 1
                      "
                      v-model="
                        assessmentList[currentRoundIndex].sentAutomatically
                      "
                      >Send Automatically
                    </b-form-checkbox>
                    <span
                      v-show="
                        automatedJob ||
                        processMap[currentRoundID].actualIndex === 1
                      "
                      class="pb-1 pl-1"
                      v-b-tooltip.hover.top="
                        automatedJob
                          ? 'Assessment will be triggered automatically as this is an automated job'
                          : 'First Round Cannot be Triggered Automatically'
                      "
                    >
                      <img src="../../../assets/img/Vector 2.svg" />
                    </span>
                  </div>
                </b-col>
                <b-col>
                  <div class="d-flex align-items-center mt-3">
                    <img
                      src="../../../assets/img/newcreatejob/interviewprocess/Line.svg"
                      alt=""
                    />
                    <div class="newmodal-input-label ml-3">
                      Passing Percentage<span class="asterik">*</span>
                    </div>
                    <div
                      class="
                        position-relative
                        newmodalinputbox
                        ml-2
                        w-45px
                        h30px
                      "
                    >
                      <b-form-input
                        @keypress="NumbersOnly"
                        class="px-2 padding-10px w-100 h-100"
                        :class="{
                          error:
                            validateObj.assessmentRounds.$each[
                              currentRoundIndex
                            ].passingPercentage.$error,
                        }"
                        v-model="
                          validateObj.assessmentRounds.$each[currentRoundIndex]
                            .passingPercentage.$model
                        "
                      >
                      </b-form-input>
                      <div
                        class="newInt-required-validation-font mt-1"
                        v-if="
                          validateObj.assessmentRounds.$each[currentRoundIndex]
                            .passingPercentage.$dirty &&
                          !validateObj.assessmentRounds.$each[currentRoundIndex]
                            .passingPercentage.required
                        "
                      >
                        Required
                      </div>
                    </div>
                    <div class="newmodal-input-label ml-3">%</div>
                  </div>
                </b-col>
              </b-row>

              <hr />
              <div class="createjob-ip-testcards-details mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="createjobs-ip-right-mainheads">Test Details</div>
                  <div class="d-flex align-items-center">
                    <div
                      class="d-flex align-items-center mr-2"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .selectedtests.$error
                      "
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/erroeicon.svg"
                        alt=""
                      />
                      <span class="ip-errortxt">Please add test</span>
                    </div>

                    <div
                      v-if="!isJdApproved"
                      class="d-flex align-items-center pointer"
                      @click="openTopicModal"
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/addplus.svg"
                        alt=""
                      />
                      <span class="createjobs-ip-add-txt ml-1">Add Test</span>
                    </div>
                  </div>
                </div>
              </div>
              <b-row class="mt-3">
                <b-col
                  cols="6"
                  v-for="(test, index) in assessmentList[currentRoundIndex]
                    .selectedtests"
                  :key="index + 'test'"
                >
                  <div
                    class="createjobs-ip-testcards"
                    :class="{ 'mt-2': index > 1 }"
                  >
                    <div class="d-flex align-items-center">
                      <div style="width: 95%">
                        <div class="createjobs-ip-testcard-mainheads">
                          Test Name
                        </div>
                        <div
                          class="
                            w-90
                            text-truncate
                            createjobs-ip-testcards-subheads
                            mt-1
                          "
                        >
                          {{ test.name }}
                        </div>
                      </div>
                      <div v-show="!isJdApproved" style="width: 5%">
                        <img
                          class="pointer"
                          v-b-tooltip.hover.bottom="'Delete'"
                          @click="$emit('delete-test', index)"
                          src="../../../assets/img/newcreatejob/interviewprocess/delete.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <hr class="my-2" />
                    <b-row>
                      <b-col>
                        <div class="createjobs-ip-testcard-mainheads">
                          Topic Name
                        </div>
                        <div
                          class="
                            text-truncate
                            mt-1
                            createjobs-ip-testcards-subheads
                          "
                        >
                          {{ test.topicName }}
                        </div>
                      </b-col>
                    </b-row>
                    <hr class="my-2" />
                    <div class="d-flex align-items-center mt-3">
                      <div class="w-33 d-flex flex-column">
                        <div class="createjobs-ip-testcard-mainheads">
                          Difficulty
                        </div>
                        <div class="createjobs-ip-testcards-subheads mt-1 ml-2">
                          {{ test.difficultyLevel }}
                        </div>
                      </div>
                      <div class="w-34 d-flex flex-column align-items-center">
                        <div class="createjobs-ip-testcard-mainheads">
                          Sections
                        </div>
                        <div class="createjobs-ip-testcards-subheads mt-1">
                          {{ test.numberOfSections }}
                        </div>
                      </div>
                      <div class="w-33 d-flex flex-column align-items-end">
                        <div class="createjobs-ip-testcard-mainheads">
                          Questions
                        </div>
                        <div class="createjobs-ip-testcards-subheads mt-1 mr-4">
                          {{ test.noOfQuestions }}
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div
                v-if="
                  assessmentList[currentRoundIndex].selectedtests.length > 0
                "
                class="mt-3 d-flex align-items-center justify-content-between"
              >
                <template
                  v-if="assessmentList[currentRoundIndex].configID === null"
                >
                  <div
                    :class="
                      validateObj.assessmentRounds.$each[currentRoundIndex]
                        .configID.$error
                        ? 'createjobs-ip-testcards-noti-container-error'
                        : 'createjobs-ip-testcards-noti-container'
                    "
                  >
                    <template
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .configID.$error
                      "
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/confignotierror.svg"
                        alt=""
                      />
                    </template>
                    <template v-else>
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/confignoti.svg"
                        alt=""
                      />
                    </template>
                    <span
                      class="ml-1"
                      :class="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .configID.$error
                          ? 'createjobs-ip-testcards-noti-txt-error'
                          : 'createjobs-ip-testcards-noti-txt'
                      "
                      >Please click on “Tag Configuration” to continue the
                      selected test(s)</span
                    >
                  </div>
                  <div
                    @click="openConfigModal"
                    class="d-flex justify-content-end pointer"
                    style="width: 30%"
                  >
                    <img
                      src="../../../assets/img/newcreatejob/interviewprocess/addplus.svg"
                      alt=""
                    />
                    <span class="ml-2 createjobs-ip-add-txt"
                      >Tag Configuration</span
                    >
                  </div>
                </template>
                <template v-else>
                  <div
                    class="
                      createjob-config-container
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div class="">
                      {{ assessmentList[currentRoundIndex].configName }}
                    </div>
                    <div class="configured-msg">Configured</div>
                  </div>
                  <div @click="openConfigModal" class="pointer">
                    <img
                      src="../../../assets/img/newcreatejob/interviewprocess/changeconfig.svg"
                      alt=""
                    />
                    <span class="ml-2 createjobs-ip-add-txt"
                      >Change Configuration</span
                    >
                  </div>
                </template>
              </div>
              <hr class="my-2" />
              <template
                v-if="assessmentList[currentRoundIndex].selectedtests.length"
              >
                <div>
                  <div
                    v-if="
                      !isJdApproved ||
                      (isJdApproved &&
                        assessmentList[currentRoundIndex].selevaluator
                          .length !== 0)
                    "
                    class="createjobs-ip-right-mainheads mt-1"
                  >
                    {{
                      isJdApproved
                        ? "List of evaluators :"
                        : "You have to assign an evaluator to evaluate this assessment"
                    }}<span
                      v-if="
                        jobData.status !== '3' &&
                        assessmentList[currentRoundIndex].isEvalRequired
                      "
                      class="asterik"
                      >*</span
                    >
                  </div>
                  <div class="position-relative w-100" v-if="!isJdApproved">
                    <div
                      ref="eval-label"
                      @click="toggleEval"
                      :class="{
                        error:
                          validateObj.assessmentRounds.$each[currentRoundIndex]
                            .selevaluator.$error,
                      }"
                      class="
                        w-100
                        select-eval-dd
                        d-flex
                        align-items-center
                        justify-content-between
                        pointer
                      "
                    >
                      <div class="select-evaldd-head">Select Evaluators</div>
                      <div>
                        <img
                          v-if="!showEvaluators"
                          src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.assessmentRounds.$each[currentRoundIndex]
                          .selevaluator.$dirty &&
                        !validateObj.assessmentRounds.$each[currentRoundIndex]
                          .selevaluator.required
                      "
                    >
                      Required
                    </div>
                    <div
                      class="select-eval-dd-card"
                      ref="eval-list"
                      v-show="showEvaluators"
                      v-closable="{
                        exclude: ['eval-label', 'eval-list'],
                        handler: 'closeEval',
                      }"
                    >
                      <div
                        class="
                          sip
                          relativeclass
                          aoeinput
                          opt-check
                          new-form-check
                        "
                      >
                        <div class="cj-ip-searchicon">
                          <img
                            src="../../../assets/img/accesscontrol/inputsearch.svg"
                            alt=""
                          />
                        </div>
                        <b-form-input
                          class="inputField pl-4"
                          type="search"
                          placeholder="Search"
                          @input="(evalPage = 0), getEvaluators()"
                          @keyup="(evalPage = 0), getEvaluators()"
                          v-model="searchEval"
                        >
                        </b-form-input>
                      </div>
                      <div
                        @scroll="onEvalScroll"
                        class="
                          h-77
                          sendautomatically
                          common-single-checkbox
                          overflow-auto
                        "
                      >
                        <b-form-checkbox
                          class="select-eval-dd-card-input"
                          stacked
                          v-model="
                            validateObj.assessmentRounds.$each[
                              currentRoundIndex
                            ].selevaluator.$model
                          "
                          v-for="(evaluator, index) in evaluators"
                          :value="evaluator"
                          :key="index"
                        >
                          {{ evaluator.name }}
                        </b-form-checkbox>
                        <div
                          style="margin: auto"
                          v-if="showEvalLoader"
                          class="d-flex justify-content-center"
                        >
                          <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div
                          v-if="evaluators.length == 0 && searchEval != ''"
                          class="
                            mt-2
                            mb-2
                            d-flex
                            justify-content-center
                            topics-head-createjd
                          "
                        >
                          No Matching result found for '{{ searchEval }}'
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-item-center flex-wrap">
                    <div
                      v-for="(evaluator, index) in assessmentList[
                        currentRoundIndex
                      ].selevaluator"
                      :key="index + 'eval'"
                      class="
                        createjob-ip-evaluators
                        d-flex
                        align-items-center
                        mt-2
                      "
                      :class="{ 'ml-2': index > 0 }"
                    >
                      {{ evaluator.name }}
                      <img
                        v-show="!isJdApproved"
                        @click="removeEvaluator(index)"
                        src="../../../assets/img/newcreatejob/interviewprocess/tagclose.svg"
                        class="ml-2 mt-1 pointer"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="p-3">
              <b-row>
                <b-col>
                  <div class="newmodal-input-label">Start Date</div>
                  <div class="position-relative newmodalinputbox mt-1">
                    <DatePicker
                      ref="start-f2f"
                      class="w-100 startdateconfig-tc global-disabledField"
                      :class="{
                        'error-dp-tc':
                          validateObj.faceToFaceRounds.$each[currentRoundIndex]
                            .startDate.$error,
                      }"
                      placeholder="Select start date"
                      format="DD-MM-YYYY"
                      :value-type="dateValueFormat"
                      type="date"
                      v-model="
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .startDate.$model
                      "
                      :editable="false"
                      :disabled-date="disableStartDate"
                    />
                    <div
                      class="createjob-ip-calemndar pointer"
                      @click="openDate('start-f2f')"
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/calendar.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="newmodal-input-label">End Date</div>
                  <div class="position-relative newmodalinputbox mt-1">
                    <DatePicker
                      ref="end-f2f"
                      placeholder="Select end date"
                      format="DD-MM-YYYY"
                      :value-type="dateValueFormat"
                      type="date"
                      class="w-100 startdateconfig-tc global-disabledField"
                      :class="{
                        'error-dp-tc':
                          validateObj.faceToFaceRounds.$each[currentRoundIndex]
                            .endDate.$error ||
                          !validateObj.faceToFaceRounds.$each[currentRoundIndex]
                            .endDate.isDateValid,
                      }"
                      v-model="
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .endDate.$model
                      "
                      :editable="false"
                      :disabled-date="disableEndDate"
                    />
                    <div
                      class="createjob-ip-calemndar pointer"
                      @click="openDate('end-f2f')"
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/calendar.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .endDate.$dirty &&
                        !validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .endDate.isDateValid
                      "
                    >
                      End date cannot be less than current date
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .endDate.$dirty &&
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .endDate.isDateValid &&
                        (!validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .endDate.isEndDateAfterStartDatef2f ||
                          !validateObj.faceToFaceRounds.$each[currentRoundIndex]
                            .startDate.isStartDateBeforeEndDatef2f)
                      "
                    >
                      End date cannot be less than start date
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="newmodal-input-label">Duration</div>
                  <div class="position-relative newmodalinputbox mt-1">
                    <b-form-input
                      :class="{
                        error:
                          validateObj.faceToFaceRounds.$each[currentRoundIndex]
                            .duration.$error,
                      }"
                      @keypress="NumbersOnly"
                      placeholder="Enter duration in minutes"
                      v-model="
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .duration.$model
                      "
                    >
                    </b-form-input>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="
                        validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .duration.$dirty &&
                        !validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .duration.required
                      "
                    >
                      Required
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="
                        !validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .duration.integer ||
                        !validateObj.faceToFaceRounds.$each[currentRoundIndex]
                          .duration.minValue
                      "
                    >
                      Should be greater than 5 minutes
                    </div>
                  </div>
                </b-col>
              </b-row>
              <hr class="my-3" />
              <div class="createjobs-ip-right-mainheads mt-3">Job Details</div>

              <b-row class="mt-3">
                <b-col cols="4">
                  <div class="sendautomatically common-single-checkbox mt-1">
                    <b-form-checkbox
                      v-model="faceToFaceList[currentRoundIndex].showJDToPanel"
                      @change="setViewJobData"
                      >Show Job details to panelist
                    </b-form-checkbox>
                  </div>
                </b-col>
                <b-col
                  v-if="faceToFaceList[currentRoundIndex].showJDToPanel"
                  cols="4"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <span
                      :class="
                        faceToFaceList[currentRoundIndex].showJDToPanel
                          ? 'createjob-ip-switch-txt'
                          : 'createjobs-ip-disable-txt'
                      "
                      class="mr-1"
                    >
                      Basic
                    </span>
                    <b-form-checkbox
                      name="check-button"
                      class="visibility-unselected-profile-switch mb-1 ml-2"
                      :disabled="
                        !faceToFaceList[currentRoundIndex].showJDToPanel
                      "
                      size="lg"
                      switch
                      :value="2"
                      :unchecked-value="1"
                      v-model="faceToFaceList[currentRoundIndex].jdDetailsType"
                    ></b-form-checkbox>
                    <span
                      :class="
                        faceToFaceList[currentRoundIndex].showJDToPanel
                          ? 'createjob-ip-switch-txt'
                          : 'createjobs-ip-disable-txt'
                      "
                      class="ml-1"
                    >
                      All
                    </span>
                  </div>
                </b-col>
                <b-col cols="4">
                  <div
                    @click="openDetailsModal"
                    v-if="faceToFaceList[currentRoundIndex].showJDToPanel"
                    class="
                      createjobs-ip-view-txt
                      d-flex
                      justify-content-end
                      align-items-center
                      pointer
                      mt-1
                    "
                  >
                    <img
                      src="../../../assets/img/newcreatejob/interviewprocess/Eye.svg"
                      class="mr-1"
                      alt=""
                    />
                    View Details
                  </div>
                </b-col>
              </b-row>
            </div>
          </template>
        </template>
      </section>
    </section>
    <TopicModal
      :showModal="showTopicsModal"
      @close-topics-modal="closeTopicModal"
      @add-tests="addTests"
      :selectedTestIds="selectedTestIds"
      :selectedTests="
        currentRoundID !== null &&
        processMap[currentRoundID].type === 'assessment'
          ? assessmentList[currentRoundIndex].selectedtests
          : []
      "
    />

    <ViewConfig
      :showModal="showConfigModal"
      :configID="
        currentRoundID !== null &&
        processMap[currentRoundID].type === 'assessment'
          ? assessmentList[currentRoundIndex].configID
          : null
      "
      :currentRoundData="
        currentRoundID !== null &&
        processMap[currentRoundID].type === 'assessment'
          ? assessmentList[currentRoundIndex]
          : null
      "
      @select-config="selectConfig"
      @close-modal="showConfigModal = false"
    />
    <AllJobDetails
      :showAllDetailsJD="showAllDetailsJD"
      :jdDetailsType="
        currentRoundID !== null &&
        processMap[currentRoundID].type === 'faceToFace'
          ? faceToFaceList[currentRoundIndex].jdDetailsType
          : null
      "
      :basicArray="viewData.basicArray"
      :advanceArray="viewData.advanceArray"
      :panelJdDetails="{
        interviewProcess: savedIP,
        ...allocateData,
        ...jobData,
      }"
      @hideAllJobDetailsModal="
        (showAllDetailsJD = false), $emit('populate-allocate')
      "
    />
    <HiringProcessModal
      v-if="showHiringModal"
      @createNewIP="createNewIP"
      :showHiringModal="showHiringModal"
      :tab="tab"
      :interviewProcessID="interviewProcessID"
      :feedbackFormID="feedbackFormID"
      :isFeedbackFormPresent="isFeedbackFormPresent"
      @feedback-selected="onFeedbackSelected"
      @ip-selected="onIpSelected"
      @close-hiring-modal="showHiringModal = false"
    />
  </div>
</template>

<script>
import { NumbersOnly } from "../../../controllers/Candidate/helpers";
import HiringProcessModal from "../modals/HiringProcessModal.vue";
import { getEvalList } from "../../../utils/apiFunctions";
import TopicModal from "../modals/TopicModal.vue";
import ViewConfig from "../../../controllers/workbench/modals/ViewConfig.vue";
import AllJobDetails from "../../../controllers/panelLogin/modals/AllJobDetails.vue";
import { mapGetters } from "vuex";
import { convertTime } from "../../../controllers/workbench/helpers";
export default {
  name: "Interview",
  components: {
    TopicModal,
    ViewConfig,
    AllJobDetails,
    HiringProcessModal,
  },
  props: {
    viewData: Object,
    validateObj: Object,
    savedIP: Object,
    savedFeedback: Object,
    jobData: Object,
    processMap: Object,
    allocateData: Object,
    platformData: Object,
    assessmentList: Array,
    faceToFaceList: Array,
    isSaveAndApprove: Boolean,
    isFeedbackFormPresent: Boolean,
    isJdApproved: Boolean,
    interviewProcessID: String,
    feedbackFormID: String,
    currentRoundID: [String, Number, null],
    currentRoundIndex: [Number, null],
  },
  data() {
    return {
      // BOOLEAN
      showTooltipPlace: false,
      showIpLoader: false,
      showForm: false,
      showAllDetailsJD: false,
      showDropDown: false,
      showTopicsModal: false,
      showConfigModal: false,
      showEvaluators: false,
      showEvalLoader: false,
      showHiringModal: false,

      // STRINGS
      searchQuery: "",
      searchEval: "",
      dateValueFormat: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
      dateDisplayFormat: "DD-MM-YYYY HH-mm",
      tab: "interviewProcess",

      // NUMBERS
      ipPage: 0,
      ipTotal: 0,
      ipPageEnd: 0,
      evalPage: 0,
      evalPageEnd: 0,
      totalEval: 0,

      // ARRAYS
      interviewProcess: [],
      evaluators: [],
      faceToFace: [],

      // SETS
      selectedTestIds: new Set(),
    };
  },
  computed: {
    ...mapGetters({ roles: "roles" }),
    isIpSelected() {
      return this.savedIP != null && Object.keys(this.savedIP).length > 0;
    },
    isFeedbackFormSelected() {
      return (
        this.savedFeedback != null && Object.keys(this.savedFeedback).length > 0
      );
    },
    automatedJob() {
      return this.platformData?.automatic;
    },
  },
  created() {
    if (this.automatedJob && this.assessmentList.length != 0) {
      this.assessmentList.map((obj) => {
        obj.sentAutomatically = true;
        return obj;
      });
    }
  },
  methods: {
    NumbersOnly(evt) {
      NumbersOnly(evt, true);
    },
    goToHiringModal(tab) {
      this.showHiringModal = true;
      this.tab = tab;
    },
    onFeedbackSelected(feedbackFormData) {
      this.$emit("feedback-selected", feedbackFormData);
    },
    onIpSelected(interviewProcessData) {
      this.$emit("ip-selected", interviewProcessData);
    },
    getStartDate() {
      if (this.processMap[this.currentRoundID].type === "assessment") {
        return this.assessmentList[this.currentRoundIndex].openTestdt;
      } else {
        return this.faceToFaceList[this.currentRoundIndex].startDate;
      }
    },
    getEndDate() {
      if (this.processMap[this.currentRoundID].type === "assessment") {
        return this.assessmentList[this.currentRoundIndex].closeTestdt;
      } else {
        return this.faceToFaceList[this.currentRoundIndex].endDate;
      }
    },
    disableStartDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0 for accurate comparison
      return date < today; // Compare the input date with today's date
    },
    disableEndDate(date) {
      const startDate = this.getStartDate();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (startDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        return date < start || date < today;
      }
      return date < today;
    },
    disableStartTime(date) {
      const currentTime = new Date();
      const selectedDate = new Date(date);
      // Set seconds and milliseconds to 0
      selectedDate.setSeconds(0);
      selectedDate.setMilliseconds(0);
      if (selectedDate.getTime() <= currentTime.getTime()) {
        return true; // Disable if selected time is before or equal to current time
      }
    },
    openDate(ref) {
      this.$refs[ref].$el.children[0].click();
    },
    toggleEval() {
      if (!this.showEvaluators) {
        this.getEvaluators();
      }
      this.showEvaluators = !this.showEvaluators;
    },
    setViewJobData(isSelected) {
      if (isSelected) {
        this.faceToFaceList[this.currentRoundIndex].jdDetailsType = 1;
      } else {
        this.faceToFaceList[this.currentRoundIndex].jdDetailsType = 0;
      }
      this.$forceUpdate();
    },
    openDetailsModal() {
      this.$emit("generate-data");
      this.showAllDetailsJD = true;
    },
    selectConfig(config, isCloseConfigModal = false) {
      const openTestdt = this.assessmentList[this.currentRoundIndex].openTestdt;
      const closeTestdt =
        this.assessmentList[this.currentRoundIndex].closeTestdt;
      const passingPercentage =
        this.assessmentList[this.currentRoundIndex].passingPercentage;
      const duration = this.assessmentList[this.currentRoundIndex].duration;
      if (!openTestdt) {
        this.assessmentList[this.currentRoundIndex].openTestdt = convertTime(
          config.config.openTestdt,
          "india"
        );
      } else {
        config.config.openTestdt = openTestdt;
      }
      if (!closeTestdt) {
        this.assessmentList[this.currentRoundIndex].closeTestdt = convertTime(
          config.config.closeTestdt,
          "india"
        );
      } else {
        config.config.closeTestdt = closeTestdt;
      }
      if (!passingPercentage) {
        this.assessmentList[this.currentRoundIndex].passingPercentage =
          config.config.passingPercentage;
      } else {
        config.config.passingPercentage = passingPercentage;
      }
      if (!duration) {
        this.assessmentList[this.currentRoundIndex].duration =
          config.config.testDuration;
      } else {
        config.config.testDuration =
          this.assessmentList[this.currentRoundIndex].duration;
      }
      config.config.typingDuration = 60;
      this.assessmentList[this.currentRoundIndex].configID = config.configID;
      this.assessmentList[this.currentRoundIndex].config = config.config;
      this.assessmentList[this.currentRoundIndex].configName =
        config.configName;
      this.validateObj.assessmentRounds.$each[
        this.currentRoundIndex
      ].configID.$model = config.configID;
      this.showConfigModal = isCloseConfigModal;
    },
    removeEvaluator(index) {
      this.assessmentList[this.currentRoundIndex].selevaluator.splice(index, 1);
    },
    closeEval() {
      this.showEvaluators = false;
    },
    onEvalScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) + 1 >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (this.checkbetween(this.evalPageEnd, 0, this.totalEval)) {
          this.evalPage++;
          this.getEvaluators();
        }
      }
    },
    async getEvaluators() {
      try {
        let payload = {
          searchQuery: this.searchEval,
          sortBy: {
            column: "updatedAt",
            order: false,
          },
          tag: "0",
          page: this.evalPage,
          count: 10,
        };
        const response = await getEvalList(payload);
        if (response.status == 200) {
          if (this.evalPage == 0) {
            this.evaluators = response.data.data.data;
          } else {
            this.evaluators = [...this.evaluators, ...response.data.data.data];
          }
          this.showEvalLoader =
            response.data.data.total !== response.data.data.pageEnd;
        }
        this.totalEval = response.data.data.total;
        this.evalPageEnd = response.data.data.pageEnd;
      } catch (error) {
        console.error(error);
      }
    },
    resetEvaluators() {
      this.evalPageEnd = 0;
      this.totalEval = 0;
      this.searchEval = "";
      this.evaluators = [];
    },
    openConfigModal() {
      this.showConfigModal = true;
    },
    validateRound(roundID) {
      const roundType = this.processMap[roundID].type;
      if (roundType === "assessment") {
        return this.assessment.$error;
      } else {
        return this.validateObj.faceToFaceRounds.$error;
      }
    },
    deleteTest(index) {
      this.assessmentList[this.currentRoundIndex].selectedtests.splice(
        index,
        1
      );
    },
    switchRounds(roundID) {
      this.$emit("select-round", roundID);
      this.selectedTestIds.clear();
      if (this.processMap[roundID].type === "assessment") {
        this.assessmentList.forEach((assessment) => {
          if (assessment.id !== roundID) {
            assessment.testID.forEach((id) => this.selectedTestIds.add(id));
          }
        });
      }
    },
    addTests(tests) {
      let testIDs = tests.map((test) => test.testID);
      this.$emit("save-tests", tests, testIDs);
      this.closeTopicModal();
    },
    closeTopicModal() {
      this.showTopicsModal = false;
    },
    openTopicModal() {
      this.showTopicsModal = true;
    },
    checkValidRound(roundID) {
      const invalidRounds = [0, "F", "R", "NI", "H"];
      return !invalidRounds.includes(roundID);
    },
    createNewIP(name) {
      this.$emit("switch-to-ip", name);
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    hideDropDown() {
      this.showDropDown = false;
    },
    toggleDropdown() {
      if (!this.isJdApproved) {
        this.showDropDown = !this.showDropDown;
      }
    },
  },
};
</script>

<style scoped>
.disabled-ip {
  background-color: #eeeeee;
}

.ip-selected-height {
  height: calc(100vh - 493px);
  overflow: auto;
}

.new-form-check .form-control {
  border: 2px solid var(--bg-white);
}

.select-int-font {
  font-family: var(--montserrat);
  font-weight: 600;
  font-size: 14px;
  color: #344054;
}

.height-fix {
  height: 68%;
}

.new-div {
  background: var(--bg-white);
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  padding: 5px 10px;
  position: relative;
}

.new-div-head {
  font-family: var(--lato);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: var(--bluetheme);
}

.new-div-sub {
  font-family: var(--montserrat);
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  color: var(--bluetheme);
}
</style>
